import moment from 'moment';

const getEventCostDateLabel = (date?: string | null, amount?: number) => {
  return `<strong>${amount}</strong> € ${
    date ? `(pagamento effettuato il ${moment(date).format('DD/MM/YYYY')})` : ''
  }`;
};

export default getEventCostDateLabel;
